// extracted by mini-css-extract-plugin
export default {"spinner":"SlackConnect_spinner__QAYdv","spinner-d3wgkg":"SlackConnect_spinner-d3wgkg__i9Gdy"};